import { render } from "./Transacciones.vue?vue&type=template&id=2487e217"
import script from "./Transacciones.vue?vue&type=script&lang=js"
export * from "./Transacciones.vue?vue&type=script&lang=js"

import "./Transacciones.vue?vue&type=style&index=0&id=2487e217&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__